import IErrorConfig from '../../vendor_core/core/src/managers/contracts/configurations/IErrorConfig';
import { ConfigurationTypes } from '../../vendor_core/core/src/const/ConfigurationTypes';

class ErrorConfig implements IErrorConfig {

    public type: ConfigurationTypes = ConfigurationTypes.ERROR;
    public errorMap:{[key: string]: string} = {};
    public softErrorCodes: number[] = [];
    public fatalErrorCodes: number[] = [503,520,521,523,531,534,600,601];

    public getErrorMap(): {[key: string]:string} {
        let errorMap = {};
        errorMap = Object.assign({}, this.errorMap);
        return errorMap;
    }

    public getSoftErrorCodes(): number[] {
        const softEC = [...this.softErrorCodes];
        return softEC;
    }

    public getFatalErrorCodes(): number[] {
        const fatalEC = [...this.fatalErrorCodes];
        return fatalEC;
    }

    public hasErrorMap(): boolean {
        return Object.keys(this.errorMap).length > 0;
    }

    public hasSoftErrorCodes(): boolean {
        return this.softErrorCodes.length > 0;
    }

    public hasFatalErrorCodes(): boolean {
        return this.fatalErrorCodes.length > 0;
    }
}

export default new ErrorConfig()